$ = require 'jquery'
getExperiment = require 'lib/experiments/simple-test'
Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
SearchInputView = require 'views/board-menu/search-input-view'
Util = require 'lib/util'
View = require 'views/internal/view'
_ = require 'underscore'
templates = require 'views/internal/templates'
l = require 'lib/localize'

module.exports = class CardFilterView extends View
  viewTitleKey: if getExperiment('improvedBoardSearchFormFactor').get('variation') != 'control' then 'search cards' else 'filter cards'
  viewIcon: if getExperiment('improvedBoardSearchFormFactor').get('variation') != 'control' then 'search cards' else 'filter'

  className: 'board-menu-content-frame'

  initialize: ->
    @listenTo @model.board, 'change:labelNames change:memberships', @renderFilterOptions
    @listenTo @model, 'change', @renderFilterOptions

  events:
    'click .js-toggle-label-filter': 'toggleLabelFilter'
    'click .js-select-member': 'toggleMemberFilter'
    'click .js-show-all-labels': 'showAllLabels'
    'click .js-show-all-members': 'showAllMembers'
    'click .js-clear-all': 'clearFilter'
    'click .js-due-filter': 'toggleDateFilter'
    'click .js-mode-filter': 'toggleModeFilter'

    'mouseenter .js-filter-search-results li': 'hoverSelect'
    'mouseenter .js-clear-all': 'clearAllSelected'
    'mouseenter .js-show-all-members': 'clearAllSelected'

    'keydown .js-input': 'keyDownEvent'
    'keyup .js-input': 'keyUpEvent'

  render: ->
    @isFiltering = false

    data = @model.toJSON()

    @$el.html(
      templates.fill(
        'filter_cards',
        data
      )
    )

    @renderFilterOptions()
    @renderSearchInputView()

    @

  renderFilterOptions: ->
    data = @model.toJSON({ board: true, expanded: true })

    hasLabelsMatchingFilter = !_.isEmpty(data.labels)
    hasMembersMatchingFilter = !_.isEmpty(data.members)
    filtering = @model.get('title') && (hasLabelsMatchingFilter || hasMembersMatchingFilter)

    if !filtering
      limit = 6
      if @model.get('limitMembers') ? true
        # Don't show a "more" menu if we're exactly one more than the limit,
        # in that case we may as well just show the item
        if data.members.length == limit + 1
          data.limitMembers = false
        else
          data.remainingMembers = Math.max(0, data.members.length - limit)
          data.members = _.first(data.members, limit)
          data.limitMembers = data.remainingMembers > 0

      if @model.get('limitLabels') ? true
        if data.labels.length == limit + 1
          data.limitLabels = false
        else
          data.remainingLabels = Math.max(0, data.labels.length - limit)
          data.labels = _.first(data.labels, limit)
          data.limitLabels = data.remainingLabels > 0
    else
      data.limitMembers = false
      data.limitLabels = false

    _.extend data,
      filtering: filtering
      showHelper: !filtering
      showLabels: !filtering || hasLabelsMatchingFilter
      showMembers: !filtering || hasMembersMatchingFilter
      showDueTimes: !filtering
      showMatchMode: !filtering
      isFiltering: @model.isFiltering()
      labels: data.labels.map (label) ->
        defaultColorName = if label.color
          l(['labels', label.color])
        else
          ""
        _.extend { defaultColorName }, label

    @$('.js-filter-search-results').html(
      templates.fill(
        'filter_cards_search_results',
        data,
        {},
        { member: templates.member, select_member: templates.select_member }
      )
    )

    if @model.get('title') == null
      @$('.js-input').val("")

    @

  renderSearchInputView: ->
    container = @$('.js-search-input-view')

    if container.length
      subview = @subview(SearchInputView, @model)
      @appendSubview(subview, container)

  keyDownEvent: (e) ->
    key = Keyboard.getKey(e)
    if key !in [Keys.Enter, Keys.ArrowUp, Keys.ArrowDown]
      return

    Util.stop(e)

    matchesSelector = '.item, .label-list-item'

    $items = @$(matchesSelector)
    $selected = $items.filter('.selected').first()

    if key == Keys.Enter
      $selected.find('a').click()
    else if key in [Keys.ArrowUp, Keys.ArrowDown]
      if $selected.length == 0
        $items.first().addClass('selected')
      else
        Util.navMenuList(@$el, matchesSelector, key)

    return

  keyUpEvent: (e) ->
    # esc will remove the input value and subsequently the search
    # title from filter array if selected, so just return if esc
    # is hit (will close the popover like normal)
    key = Keyboard.getKey(e)
    return if key in [Keys.Escape, Keys.Enter, Keys.ArrowUp, Keys.ArrowDown]

    @model.save({
      title: @$('.js-input').val()
      limitMembers: true
      limitLabels: true
    })

  showAllMembers: (e) ->
    Util.stop(e)
    @model.save('limitMembers', false)
    return

  showAllLabels: (e) ->
    Util.stop(e)
    @model.save('limitLabels', false)
    return

  _clearAndFocusInput: ->
    @model.save({ title: "" })
    @$('.js-input').val("").focus()

  toggleLabelFilter: (e) ->
    Util.stop(e)
    # Figure this out before doing @_clearAndFocusInput, which could cause
    # a re-render
    idLabel = ($(e.target).closest('a').attr('data-idlabel'))
    # If the label they clicked matches the thing they were searching for
    # then clear the search
    data = @model.toJSON({ expanded: true })
    if !_.isEmpty(data.labels)
      @_clearAndFocusInput()
    @model.toggleIdLabel(idLabel)

  toggleMemberFilter: (e) ->
    Util.stop(e)
    # Figure this out before doing @_clearAndFocusInput, which could cause
    # a re-render
    idMember = $(e.target).closest('a').attr('idMember')
    # If the member they clicked matches the thing they were searching for
    # then clear the search
    data = @model.toJSON({ expanded: true })
    if !_.isEmpty(data.members)
      @_clearAndFocusInput()

    Util.stop(e) # Don't open the member detail if they click on the avatar
    @model.toggleMember(idMember)

  toggleDateFilter: (e) ->
    Util.stop(e)
    newDateFilter = $(e.target).closest('a').attr('time')
    if @model.get('due') == newDateFilter
      @model.save('due', null)
    else
      @model.save('due', newDateFilter)

  toggleModeFilter: (e) ->
    Util.stop(e)
    newMode = $(e.target).closest('a').attr('mode')
    if @model.get('mode') != newMode
      @model.save('mode', newMode)

  clearFilter: (e) ->
    @model.clear()

  clearAllSelected: ->
    @$('li').removeClass('selected')

  hoverSelect: (e, list) ->
    @clearAllSelected()
    Util.selectMenuItem($(e.currentTarget).closest('ul'), 'li', $(e.currentTarget))



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/card-filter-view.coffee